import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, AfterViewInit, OnDestroy, Inject, PLATFORM_ID, inject } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import * as bootstrap from 'bootstrap';
import { StorageService } from '../_services/storage.service';
import { Router, NavigationEnd } from '@angular/router';
import { AlertService } from '../_services/alert.service';
import { EnvironmentOpt } from '../shared/constants/app.constants';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { mergeApiExplorerMenu } from '../pages/api-explorer/api-explorer.menu';

declare var $: any;
//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'pe-7s-graph'
}, {
    path: '/components',
    title: 'Components',
    type: 'sub',
    icontype: 'pe-7s-plugin',
    children: [
        { path: 'buttons', title: 'Buttons', ab: 'B' },
        { path: 'grid', title: 'Grid System', ab: 'GS' },
        { path: 'panels', title: 'Panels', ab: 'P' },
        { path: 'sweet-alert', title: 'Sweet Alert', ab: 'SA' },
        { path: 'notifications', title: 'Notifications', ab: 'N' },
        { path: 'icons', title: 'Icons', ab: 'I' },
        { path: 'typography', title: 'Typography', ab: 'T' }
    ]
}, {
    path: '/forms',
    title: 'Forms',
    type: 'sub',
    icontype: 'pe-7s-note2',
    children: [
        { path: 'regular', title: 'Regular Forms', ab: 'RF' },
        { path: 'extended', title: 'Extended Forms', ab: 'EF' },
        { path: 'validation', title: 'Validation Forms', ab: 'VF' },
        { path: 'wizard', title: 'Wizard', ab: 'W' }
    ]
}, {
    path: '/tables',
    title: 'Tables',
    type: 'sub',
    icontype: 'pe-7s-news-paper',
    children: [
        { path: 'regular', title: 'Regular Tables', ab: 'RT' },
        { path: 'extended', title: 'Extended Tables', ab: 'ET' },
        { path: 'datatables.net', title: 'Datatables.net', ab: 'DT' }
    ]
}, {
    path: '/maps',
    title: 'Maps',
    type: 'sub',
    icontype: 'pe-7s-map-marker',
    children: [
        { path: 'google', title: 'Google Maps', ab: 'GM' },
        { path: 'fullscreen', title: 'Full Screen Map', ab: 'FSM' },
        { path: 'vector', title: 'Vector Map', ab: 'VM' }
    ]
}, {
    path: '/charts',
    title: 'Charts',
    type: 'link',
    icontype: 'pe-7s-graph1'

}, {
    path: '/calendar',
    title: 'Calendar',
    type: 'link',
    icontype: 'pe-7s-date'
}, {
    path: '/user-management',
    title: 'User Management',
    type: 'link',
    icontype: 'pe-7s-users'
}, {
    path: '/pages',
    title: 'Pages',
    type: 'sub',
    icontype: 'pe-7s-gift',
    children: [
        { path: 'user', title: 'User Page', ab: 'UP' },
        { path: 'login', title: 'Login Page', ab: 'LP' },
        { path: 'register', title: 'Register Page', ab: 'RP' },
        { path: 'lock', title: 'Lock Screen Page', ab: 'LSP' }
    ]
}
];

@Component({
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
    userName: any;
    userRole: string = 'Developer';
    selectedEnvironment: string = EnvironmentOpt.Sandbox;
    constructor(@Inject(PLATFORM_ID) private platformId: Object, private authService: AuthService, private storageService : StorageService, private router : Router) { }
    public menuItems!: any[];
    public menuTemp!: any[];
    public subMenus: { [key: number]: any[] } = {};
    public rootItems: any[] = [];
    public expandedNodes = new Set<number>();
    private parentOf: { [key: number]: number } = {};
    private menuCategory: string = 'home';
    // Categories whose menu tree should start collapsed
    private readonly collapsedByDefaultCategories = ['integration-guide'];
    private alertService: AlertService = inject(AlertService);
    EnvironmentOpt = EnvironmentOpt;
    private previousNavOpt: string = '';
    private destroy$ = new Subject<void>();
    isNotMobileMenu() {
        if (isPlatformBrowser(this.platformId)) {
            if ($(window).width() > 991) {
                return false;
            }
            return true;
        }
        return false;
    }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

            // const storedData = localStorage.getItem('menuItemsFormatted');
            // if (!storedData) {
            //     console.log('No menu items found in localStorage');
            //     return;
            // }
            // const parsedData = JSON.parse(storedData);
            
            // this.menuItems = parsedData.rawMenus;
            // console.log('Menu items loaded:', this.menuItems);
            
            // // Pre-calculate all submenus
            // this.menuItems.forEach(item => {
            //     if (item.pmenuId === 0) {  // Only for parent menu items
            //         const subItems = this.menuItems.filter(subItem => subItem.pmenuId === item.menuId);
            //         this.subMenus[item.menuId] = subItems;
            //         console.log(`Calculated submenus for parent ${item.menuName} (ID: ${item.menuId}):`, subItems);
            //     }
            // });
            
            // console.log('Final subMenus object:', this.subMenus);


            

            //New RBAC
            const storedData = localStorage.getItem('menuItemsFormatted');
            if (!storedData) {
                console.debug('No menu items found in localStorage');
                // return;
                this.authService.newMenu(this.storageService.getToken()).subscribe((tarekResponse:any)=>{
                        const tarekMenu = tarekResponse.data;
                        
                        // Filter items where category does not exist or is empty
                        const menuItemsWithoutCategory = tarekMenu.filter((item: any) => 
                            !item.nodeInfo?.category || item.nodeInfo.category === ''
                        );
                        
                        // Filter items where category equals 'integration-guide'
                        const integrationGuideItems = tarekMenu.filter((item: any) => 
                            item.nodeInfo?.category === 'integration-guide'
                        );

                        // Filter items where category equals 'api-explorer'
                        const apiExplorerItems = tarekMenu.filter((item: any) => 
                          item.nodeInfo?.category === 'api-explorer'
                        );
                        
                        // Parse queryParams strings into objects before storing
                        const parseQueryParams = (items: any[]) => items.forEach(item => {
                          if (typeof item.nodeInfo?.queryParams === 'string' && item.nodeInfo.queryParams.trim() !== '') {
                            try {
                              item.nodeInfo.queryParams = new Function('return (' + item.nodeInfo.queryParams + ')')();
                            } catch {
                              item.nodeInfo.queryParams = {};
                            }
                          } else {
                            item.nodeInfo.queryParams = item.nodeInfo?.queryParams || {};
                          }
                        });
                        parseQueryParams(menuItemsWithoutCategory);
                        parseQueryParams(integrationGuideItems);
                        parseQueryParams(apiExplorerItems);

                        // Store filtered results in localStorage
                        localStorage.setItem('menuItemsFormatted', JSON.stringify(menuItemsWithoutCategory));
                        localStorage.setItem('menuItemsFormattedIntegrationGuide', JSON.stringify(integrationGuideItems));
                        localStorage.setItem('menuItemsFormattedApiExplorer', JSON.stringify(mergeApiExplorerMenu(apiExplorerItems)));
                        
                        // Load the appropriate menu items based on current route
                        this.loadMenuBasedOnRoute(this.router.url);
                    })
            } else {
                // Load the appropriate menu items based on current route
                this.loadMenuBasedOnRoute(this.router.url);
            }
            
            // Initialize previousNavOpt based on current route
            if(this.router.url.includes('/integration-guide')){
              this.previousNavOpt = 'integration-guide';
            } else if(this.router.url.includes('/api-explorer')){
                this.previousNavOpt = 'api-explorer';
            } else {
              this.previousNavOpt = 'home';
            }
            
            // Subscribe to route changes to update menu dynamically
            this.router.events.pipe(
                filter(event => event instanceof NavigationEnd),
                takeUntil(this.destroy$)
            ).subscribe((event: NavigationEnd) => {
              let currentNavOpt: any;
              if(event.url.includes('/integration-guide')){
                currentNavOpt = 'integration-guide';
              } else if(event.url.includes('/api-explorer')){
                currentNavOpt = 'api-explorer';
              } else {
                currentNavOpt = 'home';
              }
              console.debug("previousNavOpt: ", this.previousNavOpt, "currentNavOpt: ", currentNavOpt);
              // Only reload if we're switching between NavBar options
              if (this.previousNavOpt !== currentNavOpt) {
                this.loadMenuBasedOnRoute(event.url);
                this.previousNavOpt = currentNavOpt;
              } else {
                this.expandActiveBranch(event.url);
              }
            });
            
            this.menuTemp = ROUTES.filter(menuItem => menuItem);
            isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
            
            if (isWindows) {
                $('.sidebar .sidebar-wrapper, .main-panel').perfectScrollbar();
                $('html').addClass('perfect-scrollbar-on');
            } else {
                $('html').addClass('perfect-scrollbar-off');
            }
        }

        // Check localStorage for firstName first (in case it was stored during login)
        const storedFirstName = localStorage.getItem('firstName');
        if (storedFirstName) {
            this.userName = storedFirstName;
        }

        // Load selected environment from localStorage
        const storedEnvironment = localStorage.getItem('environment');
        if (storedEnvironment) {
            this.selectedEnvironment = storedEnvironment;
        } else {
            this.selectedEnvironment = EnvironmentOpt.Sandbox;
            localStorage.setItem('environment', EnvironmentOpt.Sandbox);
        }

        this.loadProfile();
    }

  loadProfile() {
    this.authService.getUserProfile().subscribe((response:any)=>{
      if (response?.response?.status === 200 && response?.response?.data) {
        const profileData = response.response.data;
        // Extract first name from fullName (if fullName contains both first and last name)
        let firstName = profileData.firstName || profileData.fullName;
        if (firstName && firstName.includes(' ')) {
          firstName = firstName.split(' ')[0];
        }
        // Store and display first name
        if (firstName) {
          localStorage.setItem('firstName', firstName);
          this.userName = firstName;
        } else if (profileData.fullName) {
          // Fallback to fullName if firstName is not available
          localStorage.setItem('firstName', profileData.fullName);
          this.userName = profileData.fullName;
        }
        let roleName = profileData.roleName; // it could be Developer Pay10 Admin, Developer Admin and Developer
        if (roleName) {
          if(roleName !== 'Developer'){
            roleName = roleName.replace('Developer ', '');
          }
          this.userRole = roleName;
        }
        if (profileData.merchantId) {
          localStorage.setItem('merchantId', profileData.merchantId);
        }
      }
    }, (error) => {
      console.error('Failed to load user profile:', error);
      // Try to get from localStorage if API fails
      const storedFirstName = localStorage.getItem('firstName');
      if (storedFirstName) {
        this.userName = storedFirstName;
      }
    })
  }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    toggleCollapse(nodeId: any, event: Event) {
        event.preventDefault();
        this.toggleNode(nodeId);
    }

    // Toggle without touching the event, so routerLink navigation still happens
    toggleNode(nodeId: any) {
        if (this.expandedNodes.has(nodeId)) {
            this.expandedNodes.delete(nodeId);
        } else {
            this.expandedNodes.add(nodeId);
        }
    }

    isExpanded(nodeId: any): boolean {
        return this.expandedNodes.has(nodeId);
    }

    trackByNodeId(_index: number, item: any): any {
        return item.nodeId;
    }

    hasChildren(nodeId: any): boolean {
        return (this.subMenus[nodeId]?.length ?? 0) > 0;
    }

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            // Set initial active state
            const activeParent = document.querySelector('.sidebar .nav > li.active');
            if (activeParent) {
                const collapseId = activeParent.querySelector('a[data-bs-toggle="collapse"]')?.getAttribute('href')?.substring(1);
                if (collapseId) {
                    const targetElement = document.getElementById(collapseId);
                    if (targetElement) {
                        const bsCollapse = new bootstrap.Collapse(targetElement);
                        bsCollapse.show();
                    }
                }
            }
        }
    }

    getSubMenuItems(parentId: number) {
        // console.debug('Accessing submenus for parentId:', parentId, 'Result:', this.subMenus[parentId] || []);
        return this.subMenus[parentId] || [];
    }
    showSignOutAlert(): void {
        this.alertService.customInfoPopup({
          icon: 'assets/img/Info.svg',
          title: "You'll be signed out of this account",
          description: 'After logging out, you\'ll need to sign in again to access your data or features.',
          primaryButton: {
            text: 'Log Out',
            action: () => this.authService.logout()
          },
          secondaryButton: {
            text: 'Cancel',
            action: () => {}
          }
        });
      }

    logout() {
        this.showSignOutAlert();
    }

    selectEnvironment(environment: EnvironmentOpt) {
        this.selectedEnvironment = environment;
        localStorage.setItem('environment', environment);
        // You can add additional logic here to switch between environments
        console.log('Environment switched to:', environment);
        
        // Force reload the current page to refresh the main panel
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
        });
    }

    navigateToUserProfile() {
        this.router.navigate(['/profile']);
        this.changeMenuName('Profile');
    }

    changeMenuName(menuName:any){
        // console.debug(menuName);
        localStorage.setItem('selectedMenu', menuName);
    }

    goToDashboard(){
        // console.debug("dashboard")
        localStorage.setItem('selectedMenu', 'Dashboard');
        this.router.navigate(['/dashboard']);
    }

    sortItemsById() :any {
        console.log(this.menuItems)
    this.menuItems.sort((a, b) => a.position - b.position);
    // console.debug(this.menuItems.sort((a, b) => a.position - b.position))
  }

  sortOnlyMenuItems() {
    // Separate menu items and non-menu items
    const menuItems = this.menuItems;  
    // Sort only the menu items by position
    menuItems.sort((a, b) => a.position - b.position);
    // console.debug(menuItems)
    this.menuItems = [...menuItems];
  }

  getSubMenus(parentMenuId:any) : any{
    // console.debug(parentMenuId)
    // return [{"menuName": "Test A1", "menuLink": "/dynamic-qr-code", "permissionID": "255", "menuId": 191, "position": 1, "pmenuId": 190},   
    //                   {"menuName": "Test A2", "menuLink": "/dynamic-qr-code", "permissionID": "255", "menuId": 191, "position": 2, "pmenuId": 190},
    //                   {"menuName": "Test C2", "menuLink": "/dynamic-qr-code", "permissionID": "255", "menuId": 191, "position": 2, "pmenuId": 0},
    //                   {"menuName": "Test B2", "menuLink": "/dynamic-qr-code", "permissionID": "255", "menuId": 191, "position": 1, "pmenuId": 193},
    //                   {"menuName": "Test B2", "menuLink": "/dynamic-qr-code", "permissionID": "255", "menuId": 191, "position": 2, "pmenuId": 193},
    //                 ].filter(field=> field.pmenuId === parentMenuId)
  }

  private loadMenuBasedOnRoute(url: string) {
    this.menuCategory = url.includes('/integration-guide')
      ? 'integration-guide'
      : url.includes('/api-explorer') ? 'api-explorer' : 'home';

    if (url.includes('/integration-guide')) {
      // Load Integration Guide menu
      const integrationGuideData = localStorage.getItem('menuItemsFormattedIntegrationGuide');
      if (integrationGuideData) {
        this.menuItems = JSON.parse(integrationGuideData);
        console.debug("menuItems: ", this.menuItems);
      } else {
        this.menuItems = [];
      }
    } else if(url.includes('/api-explorer')) {
      // Load API Explorer menu (merge static Bulk Payout entries if RBAC lacks them)
      const apiExplorerData = localStorage.getItem('menuItemsFormattedApiExplorer');
      const merged = mergeApiExplorerMenu(apiExplorerData ? JSON.parse(apiExplorerData) : []);
      localStorage.setItem('menuItemsFormattedApiExplorer', JSON.stringify(merged));
      this.menuItems = merged;
    } else {
      // Load default menu
      const defaultMenuData = localStorage.getItem('menuItemsFormatted');
      if (defaultMenuData) {
        this.menuItems = JSON.parse(defaultMenuData);
      } else {
        this.menuItems = [];
      }
    }
    
    // Recalculate submenus after loading menu items
    this.subMenus = {};
    this.rootItems = [];
    if (this.menuItems) {
      const idSet = new Set(this.menuItems.map(item => item.nodeId));

      this.menuItems.forEach(item => {
        const parentId = item.parentId;
        if (parentId != null && idSet.has(parentId)) {
          if (!this.subMenus[parentId]) {
            this.subMenus[parentId] = [];
          }
          this.subMenus[parentId].push(item);
        } else {
          this.rootItems.push(item);
        }
      });

      const byPosition = (a: any, b: any) =>
        Number(a.nodeInfo?.position ?? 0) - Number(b.nodeInfo?.position ?? 0);

      this.rootItems.sort(byPosition);
      Object.keys(this.subMenus).forEach(key => this.subMenus[+key].sort(byPosition));

      this.parentOf = {};
      this.menuItems.forEach(item => {
        if (item.parentId != null && idSet.has(item.parentId)) {
          this.parentOf[item.nodeId] = item.parentId;
        }
      });
    }

    this.applyDefaultExpansion(url);
  }

  private applyDefaultExpansion(url: string) {
    this.expandedNodes.clear();

    if (!this.collapsedByDefaultCategories.includes(this.menuCategory)) {
      // Expanded by default: open every node that has children
      Object.keys(this.subMenus).forEach(key => this.expandedNodes.add(+key));
      return;
    }

    // Collapsed by default: only reveal the branch leading to the active route
    this.expandActiveBranch(url);
  }

  private expandActiveBranch(url: string) {
    const activeNode = this.findNodeForUrl(url);
    if (!activeNode) return;

    let parentId: number | undefined = this.parentOf[activeNode.nodeId];
    while (parentId != null) {
      this.expandedNodes.add(parentId);
      parentId = this.parentOf[parentId];
    }
  }

  private findNodeForUrl(url: string): any | undefined {
    if (!this.menuItems || this.menuItems.length === 0) return undefined;

    const [rawPath, rawQuery] = url.split('?');
    const params = new URLSearchParams(rawQuery || '');

    return this.menuItems.find(item => {
      const menuLink = item.nodeInfo?.menuLink;
      if (!menuLink || menuLink !== rawPath) return false;

      const queryParams = item.nodeInfo?.queryParams || {};
      const keys = Object.keys(queryParams);
      if (keys.length === 0) return true;
      return keys.every(key => params.get(key) === String(queryParams[key]));
    });
  }

  parseQueryParams(queryString: string): Record<string, string> {
    if (!queryString) return {};
    return Object.fromEntries(new URLSearchParams(queryString));
  }
}